import { cardImageSources, type GenericCharacter } from './types'

export const genericUnicornio: GenericCharacter = {
  id: 'generic-unicornio',
  enabled: true,
  order: 3,
  displayName: 'Estela',
  icon: '🦄',
  imageSources: cardImageSources('generic-unicornio'),
  previewVideoSrc: '/videos/previews/generic-unicornio.mp4',
}
